import styled from "styled-components";
import { Link } from "react-router-dom";
import { PrimaryColor } from "../GlobalElements";

export const LogoWrapper = styled.div``;

export const LogoLink = styled(Link)`
  font-size: 2rem;
  color: ${PrimaryColor};
`;
